import { render, staticRenderFns } from "./HistoryEight.vue?vue&type=template&id=256b771c&scoped=true&"
import script from "./HistoryEight.vue?vue&type=script&lang=js&"
export * from "./HistoryEight.vue?vue&type=script&lang=js&"
import style0 from "./HistoryEight.vue?vue&type=style&index=0&id=256b771c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b771c",
  null
  
)

export default component.exports